<template>
  <div class="turnOnOffTime">
    <div class="form">
      <div class="grid">
        <div class="grid__column--six">
          <div class="form__group">
            <label class="form__label" for="turn_on_time">Turn on time:</label>
            <span class="form__error" v-if="errors.has('turn_on_time')">{{ errors.first('turn_on_time') }}</span>
            <input
              type="time" id="turn_on_time" name="turn_on_time"
              class="form__input" :class="{ 'form__input--error': errors.has('turn_on_time') }"
              v-validate="{ required: true }"
              v-model="turn_on_time"
            />
          </div>
        </div>
        <div class="grid__column--six">
          <div class="form__group">
            <label class="form__label" for="turn_off_time">Turn off time:</label>
            <span class="form__error" v-if="errors.has('turn_off_time')">{{ errors.first('turn_off_time') }}</span>
            <input
              type="time" id="turn_off_time" name="turn_off_time"
              class="form__input" :class="{ 'form__input--error': errors.has('turn_off_time') }"
              v-validate="{ required: true }"
              v-model="turn_off_time"
            />
          </div>
        </div>
        <div class="grid__column--twelve">
          <button type="button" @click="changeTime" class="btn btn--primary">Apply to all screens</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from '@/model/Slider'

export default {
  props: ['slider', 'slides'],
  data () {
    return {
      turn_on_time: '',
      turn_off_time: '',
      sliders: []
    }
  },
  mounted () {
    Slider.index({allPages: true, screen_ip: true}).then((response) => {
      this.sliders = response.data.data
      this.turn_on_time = this.sliders[0].additionals.turn_on_time
      this.turn_off_time = this.sliders[0].additionals.turn_off_time
    })
  },
  methods: {
    changeTime () {
      let allPromieses = []
      this.sliders.forEach((slider) => {
        allPromieses.push(Slider.update({id: slider.id, additionals: { turn_on_time: this.turn_on_time, turn_off_time: this.turn_off_time, screen_ip: slider.additionals.screen_ip }}, false))
      })
      axios.all(allPromieses).then(axios.spread(() => {
        this.$snotify.success('Successfully updated.')
      }))
    }
  }
}
</script>

<style lang="stylus">
.turnOnOffTime
    border-bottom 1px solid #eee
</style>



// WEBPACK FOOTER //
// src/components/Screen/TurnOnOffTime.vue